import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M11 5h-6a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-6","key":"svg-0"}],["path",{"d":"M3 13h6a2 2 0 0 1 2 2v6","key":"svg-1"}],["path",{"d":"M16 3h5v5","key":"svg-2"}],["path",{"d":"M21 3l-6 6","key":"svg-3"}]]

const IconQueuePopOut = createReactComponent('outline', 'queue-pop-out', 'QueuePopOut', __iconNode);

export default IconQueuePopOut;